module.exports = require("live/components/events/lib/store");